import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#284E3C',
    secondary: '#D6AC5C',
    accent: '#D6AC5C'
  }
})
